(function (_, kotlin_kotlin, kotlin_com_squareup_cash_multiplatform_money_formatter_config) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.b;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.e1;
  var DollarsAndCents = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.b;
  var Dollars = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.c;
  var Cents = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.a;
  var Cents_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.l;
  var numberRangeToNumber = kotlin_kotlin.$_$.m;
  var Abbreviated = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.e;
  var Full = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.f;
  var TrailingZeroesBehavior_SHOW_TWO_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.k;
  var TrailingZeroesBehavior_SHOW_ALL_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.i;
  var SignOption_ACCOUNTING_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.h;
  var toString = kotlin_kotlin.$_$.t;
  var replace = kotlin_kotlin.$_$.x;
  var protoOf = kotlin_kotlin.$_$.r;
  var classMeta = kotlin_kotlin.$_$.f;
  var VOID = kotlin_kotlin.$_$.f1;
  var setMetadataFor = kotlin_kotlin.$_$.s;
  var Companion_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.m;
  var MoneyFormatterConfig = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.d;
  var objectMeta = kotlin_kotlin.$_$.q;
  var interfaceMeta = kotlin_kotlin.$_$.l;
  var Unit_getInstance = kotlin_kotlin.$_$.d;
  var Enum = kotlin_kotlin.$_$.a1;
  var THROW_ISE = kotlin_kotlin.$_$.d1;
  var TrailingZeroesBehavior_SHOW_NONE_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.j;
  var numberToInt = kotlin_kotlin.$_$.n;
  var defineProp = kotlin_kotlin.$_$.h;
  var numberToLong = kotlin_kotlin.$_$.o;
  var Long = kotlin_kotlin.$_$.b1;
  var abs = kotlin_kotlin.$_$.v;
  var objectCreate = kotlin_kotlin.$_$.p;
  var removePrefix = kotlin_kotlin.$_$.w;
  var compareTo = kotlin_kotlin.$_$.g;
  var RoundingMode_HALF_UP_getInstance = kotlin_com_squareup_cash_multiplatform_money_formatter_config.$_$.g;
  var abs_0 = kotlin_kotlin.$_$.u;
  var getNumberHashCode = kotlin_kotlin.$_$.j;
  var THROW_CCE = kotlin_kotlin.$_$.c1;
  var equals = kotlin_kotlin.$_$.i;
  var toLong = kotlin_kotlin.$_$.y;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.a;
  var joinToString = kotlin_kotlin.$_$.e;
  var Char = kotlin_kotlin.$_$.z;
  //endregion
  //region block: pre-declaration
  setMetadataFor(MoneyFormatter, 'MoneyFormatter', interfaceMeta);
  setMetadataFor(MoneyFormatter$Companion$create$1, VOID, classMeta, VOID, [MoneyFormatter]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(NumberStyle, 'NumberStyle', classMeta, Enum);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(Currency, 'Currency', classMeta, Enum);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(ISONumericCode, 'ISONumericCode', classMeta, Enum);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(ISOTextCode, 'ISOTextCode', classMeta, Enum);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(Amount, 'Amount', classMeta);
  setMetadataFor(NumberFormat$1, VOID, classMeta);
  setMetadataFor(Money, 'Money', classMeta);
  //endregion
  function toAmount(_this__u8e3s4) {
    return fromLong(_this__u8e3s4);
  }
  function get_TEN() {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return TEN;
  }
  var TEN;
  function get_ONE_HUNDRED() {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return ONE_HUNDRED;
  }
  var ONE_HUNDRED;
  function get_ONE_THOUSAND() {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return ONE_THOUSAND;
  }
  var ONE_THOUSAND;
  function get_ONE_MILLION() {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return ONE_MILLION;
  }
  var ONE_MILLION;
  function get_ONE_BILLION() {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return ONE_BILLION;
  }
  var ONE_BILLION;
  function get_ONE_TRILLION() {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return ONE_TRILLION;
  }
  var ONE_TRILLION;
  function get_MINUS() {
    return MINUS;
  }
  var MINUS;
  function format(money, locale, numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (shouldFormatAsCents(money, denominationOption)) {
      tmp = formatAsCents(money, locale, numberFormat, currencyRepresentationOption, signOption, zeroBiasOption);
    } else {
      tmp = formatAsDollars(money, locale, numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption);
    }
    return tmp;
  }
  function shouldFormatAsCents(amount, denominationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (denominationOption instanceof Cents) {
      tmp = true;
    } else {
      if (denominationOption instanceof Dollars) {
        tmp = false;
      } else {
        if (denominationOption instanceof DollarsAndCents) {
          tmp = denominationOption.showsAsCentsIfPossible ? belowOneDollar(amount) : false;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function formatAsCents(money, locale, numberFormat, currencyRepresentationOption, signOption, zeroBiasOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var amount = resolveAmount(money, Cents_getInstance());
    var fractionDigitRange = numberRangeToNumber(0, 0);
    var amountToFormat = resolveAmountToFormat(amount, numberFormat, fractionDigitRange, signOption);
    var unsignedAmount = format_0(amountToFormat, money.currency, locale, fractionDigitRange, NumberStyle_NUMBER_getInstance());
    var signedAmount = appendSign(amount, unsignedAmount, signOption, zeroBiasOption);
    var abbreviatedAmount = appendAbbreviation(signedAmount, amount, numberFormat);
    return appendCents(abbreviatedAmount, money, currencyRepresentationOption);
  }
  function formatAsDollars(money, locale, numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var amount = resolveAmount(money, denominationOption);
    var fractionDigitRange = resolveFractionDigitRange(money, numberFormat, denominationOption);
    var amountToFormat = resolveAmountToFormat(amount, numberFormat, fractionDigitRange, signOption);
    var numberStyle = resolveNumberStyle(currencyRepresentationOption, signOption);
    var unsignedAmount = format_0(amountToFormat, money.currency, locale, fractionDigitRange, numberStyle);
    var signedAmount = appendSign(amount, unsignedAmount, signOption, zeroBiasOption);
    var abbreviatedAmount = appendAbbreviation(signedAmount, amount, numberFormat);
    return appendCode(abbreviatedAmount, money, currencyRepresentationOption);
  }
  function resolveAmount(money, denominationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (denominationOption instanceof Cents) {
      tmp = money.centsAmount;
    } else {
      if (denominationOption instanceof Dollars) {
        tmp = dollarAmount(money).roundToWholeNumber(denominationOption.roundingMode);
      } else {
        if (denominationOption instanceof DollarsAndCents) {
          var tmp_0;
          if (denominationOption.showsAsCentsIfPossible ? belowOneDollar(money) : false) {
            tmp_0 = money.centsAmount;
          } else {
            tmp_0 = dollarAmount(money);
          }
          tmp = tmp_0;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function resolveFractionDigitRange(money, numberFormat, denominationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (numberFormat instanceof Full) {
      // Inline function 'kotlin.let' call
      var tmp0_let = resolveFullFractionDigitCount(money, denominationOption);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.squareup.cash.common.moneyformatter.resolveFractionDigitRange.<anonymous>' call
      tmp = numberRangeToNumber(tmp0_let, tmp0_let);
    } else {
      if (numberFormat instanceof Abbreviated) {
        tmp = resolveAbbreviatedFractionDigitRange(money, numberFormat.fractionDigitsStrategy, denominationOption);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function resolveFullFractionDigitCount(money, denominationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (denominationOption instanceof Cents) {
      tmp = 0;
    } else {
      if (denominationOption instanceof Dollars) {
        tmp = 0;
      } else {
        if (denominationOption instanceof DollarsAndCents) {
          var tmp_0;
          if (denominationOption.omitsCentsIfPossible ? amountIsWholeDollarAmount(money) : false) {
            tmp_0 = 0;
          } else {
            if (denominationOption.showsAsCentsIfPossible ? belowOneDollar(money) : false) {
              tmp_0 = 0;
            } else {
              var tmp1_elvis_lhs = denominationOption.trailingZeroesBehavior;
              if ((tmp1_elvis_lhs == null ? money.currency.trailingZeroesBehavior : tmp1_elvis_lhs).equals(TrailingZeroesBehavior_SHOW_ALL_getInstance())) {
                tmp_0 = money.currency.centDigits;
              } else {
                var tmp2_elvis_lhs = denominationOption.trailingZeroesBehavior;
                if ((tmp2_elvis_lhs == null ? money.currency.trailingZeroesBehavior : tmp2_elvis_lhs).equals(TrailingZeroesBehavior_SHOW_TWO_getInstance())) {
                  tmp_0 = 2;
                } else {
                  var amount = money.centsAmount.absoluteValue();
                  var digits = money.currency.centDigits;
                  while ((amount.isWholeNumber() ? amount.compareTo(Companion_getInstance_4().ZERO) > 0 : false) ? digits > 0 : false) {
                    amount = amount.shiftDecimalPoint(-1);
                    if (amount.isWholeNumber()) {
                      digits = digits - 1 | 0;
                    }
                  }
                  tmp_0 = digits;
                }
              }
            }
          }
          tmp = tmp_0;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function resolveAbbreviatedFractionDigitRange(money, fractionDigitsStrategy, denominationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (denominationOption instanceof Cents) {
      tmp = money.centsAmount;
    } else {
      if (denominationOption instanceof Dollars) {
        tmp = dollarAmount(money);
      } else {
        if (denominationOption instanceof DollarsAndCents) {
          tmp = dollarAmount(money);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var absoluteAmount = tmp.absoluteValue();
    if (absoluteAmount.compareTo(get_ONE_THOUSAND()) < 0) {
      // Inline function 'kotlin.let' call
      var tmp0_let = resolveFullFractionDigitCount(money, denominationOption);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.squareup.cash.common.moneyformatter.resolveAbbreviatedFractionDigitRange.<anonymous>' call
      return numberRangeToNumber(tmp0_let, tmp0_let);
    }
    var shiftedAmount = absoluteAmount;
    while (shiftedAmount.compareTo(get_ONE_THOUSAND()) >= 0) {
      shiftedAmount = shiftedAmount.shiftDecimalPoint(-3);
    }
    var wholeDigits = shiftedAmount.compareTo(get_ONE_HUNDRED()) >= 0 ? 3 : shiftedAmount.compareTo(get_TEN()) >= 0 ? 2 : 1;
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.squareup.cash.common.moneyformatter.resolveAbbreviatedFractionDigitRange.<anonymous>' call
    var tmp$ret$2;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = fractionDigitsStrategy.maximumFractionDigits;
    var tmp1_min = fractionDigitsStrategy.maximumTotalDigits - wholeDigits | 0;
    tmp$ret$2 = Math.min(tmp0_min, tmp1_min);
    return numberRangeToNumber(fractionDigitsStrategy.minimumFractionDigits, tmp$ret$2);
  }
  function resolveAmountToFormat(amount, numberFormat, fractionDigitRange, signOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (numberFormat instanceof Full) {
      tmp = amount;
    } else {
      if (numberFormat instanceof Abbreviated) {
        tmp = resolveAbbreviatedAmountToFormat(amount, numberFormat, fractionDigitRange);
      } else {
        noWhenBranchMatchedException();
      }
    }
    var amountToFormat = tmp;
    var tmp_0;
    switch (signOption.p6_1) {
      case 3:
        tmp_0 = amountToFormat;
        break;
      case 0:
      case 1:
      case 2:
      case 4:
        tmp_0 = amountToFormat.absoluteValue();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_0;
  }
  function resolveAbbreviatedAmountToFormat(amount, numberFormat, fractionDigitRange) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var shiftedAmount = amount;
    while (shiftedAmount.absoluteValue().compareTo(get_ONE_THOUSAND()) >= 0) {
      shiftedAmount = shiftedAmount.shiftDecimalPoint(-3);
    }
    return shiftedAmount.round(fractionDigitRange.n1_1, numberFormat.roundingMode);
  }
  function resolveNumberStyle(currencyRepresentationOption, signOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    switch (currencyRepresentationOption.p6_1) {
      case 0:
      case 2:
        tmp = signOption.equals(SignOption_ACCOUNTING_getInstance()) ? NumberStyle_CURRENCY_ACCOUNTING_getInstance() : NumberStyle_CURRENCY_getInstance();
        break;
      case 3:
      case 1:
      case 4:
        tmp = NumberStyle_NUMBER_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function appendSign(amount, unsignedAmount, signOption, zeroBiasOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    return amount.compareTo(Companion_getInstance_4().ZERO) > 0 ? appendSignToPositiveAmount(unsignedAmount, signOption) : amount.compareTo(Companion_getInstance_4().ZERO) < 0 ? appendSignToNegativeAmount(unsignedAmount, signOption) : appendSignToZeroAmount(unsignedAmount, zeroBiasOption);
  }
  function appendSignToPositiveAmount(unsignedAmount, signOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    switch (signOption.p6_1) {
      case 1:
      case 2:
        tmp = '+' + unsignedAmount;
        break;
      case 0:
      case 3:
      case 4:
        tmp = unsignedAmount;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function appendSignToNegativeAmount(unsignedAmount, signOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    switch (signOption.p6_1) {
      case 0:
      case 1:
        tmp = '\u2212' + unsignedAmount;
        break;
      case 2:
      case 3:
      case 4:
        tmp = unsignedAmount;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function appendSignToZeroAmount(unsignedAmount, zeroBiasOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    switch (zeroBiasOption.p6_1) {
      case 2:
        tmp = '+' + unsignedAmount;
        break;
      case 1:
        tmp = '\u2212' + unsignedAmount;
        break;
      case 0:
        tmp = unsignedAmount;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function appendAbbreviation(amount, originalAmount, numberFormat) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    if (numberFormat instanceof Full) {
      tmp = amount;
    } else {
      if (numberFormat instanceof Abbreviated) {
        var absoluteOriginalAmount = originalAmount.absoluteValue();
        var tmp_0;
        switch (numberFormat.unitMagnitudeFormat.p6_1) {
          case 1:
            tmp_0 = absoluteOriginalAmount.compareTo(get_ONE_TRILLION()) >= 0 ? amount + '\xA0Trillion' : absoluteOriginalAmount.compareTo(get_ONE_BILLION()) >= 0 ? amount + '\xA0Billion' : absoluteOriginalAmount.compareTo(get_ONE_MILLION()) >= 0 ? amount + '\xA0Million' : absoluteOriginalAmount.compareTo(get_ONE_THOUSAND()) >= 0 ? amount + '\xA0Thousand' : amount;
            break;
          case 0:
            tmp_0 = absoluteOriginalAmount.compareTo(get_ONE_TRILLION()) >= 0 ? amount + 'T' : absoluteOriginalAmount.compareTo(get_ONE_BILLION()) >= 0 ? amount + 'B' : absoluteOriginalAmount.compareTo(get_ONE_MILLION()) >= 0 ? amount + 'M' : absoluteOriginalAmount.compareTo(get_ONE_THOUSAND()) >= 0 ? amount + 'K' : amount;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function appendCents(signedAmount, money, currencyRepresentationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    switch (currencyRepresentationOption.p6_1) {
      case 0:
      case 2:
        return signedAmount + money.currency.centSymbol;
      case 3:
        return signedAmount + '\xA0' + money.currency.centString(money.centsAmount);
      default:
        return signedAmount;
    }
  }
  function appendCode(signedAmount, money, currencyRepresentationOption) {
    _init_properties_CommonMoneyFormatter_kt__qwa8d1();
    var tmp;
    switch (currencyRepresentationOption.p6_1) {
      case 1:
      case 2:
        var tmp1_elvis_lhs = money.currency.syntheticTextCode;
        tmp = signedAmount + '\xA0' + toString(tmp1_elvis_lhs == null ? money.currency.isoTextCode : tmp1_elvis_lhs);
        break;
      default:
        tmp = signedAmount;
        break;
    }
    return tmp;
  }
  var properties_initialized_CommonMoneyFormatter_kt_r3dbiv;
  function _init_properties_CommonMoneyFormatter_kt__qwa8d1() {
    if (!properties_initialized_CommonMoneyFormatter_kt_r3dbiv) {
      properties_initialized_CommonMoneyFormatter_kt_r3dbiv = true;
      TEN = Companion_getInstance_4().ONE.shiftDecimalPoint(1);
      ONE_HUNDRED = Companion_getInstance_4().ONE.shiftDecimalPoint(2);
      ONE_THOUSAND = Companion_getInstance_4().ONE.shiftDecimalPoint(3);
      ONE_MILLION = Companion_getInstance_4().ONE.shiftDecimalPoint(6);
      ONE_BILLION = Companion_getInstance_4().ONE.shiftDecimalPoint(9);
      ONE_TRILLION = Companion_getInstance_4().ONE.shiftDecimalPoint(12);
    }
  }
  function belowOneDollar(_this__u8e3s4) {
    return dollarAmount(_this__u8e3s4).absoluteValue().compareTo(Companion_getInstance_4().ONE) < 0;
  }
  function dollarAmount(_this__u8e3s4) {
    return _this__u8e3s4.centsAmount.shiftDecimalPoint(-_this__u8e3s4.currency.centDigits | 0);
  }
  function amountIsWholeDollarAmount(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.currency.centDigits === 0) {
      tmp = true;
    } else {
      tmp = dollarAmount(_this__u8e3s4).isWholeNumber();
    }
    return tmp;
  }
  function MoneyFormatter$Companion$create$1($config) {
    this.a9_1 = $config;
  }
  protoOf(MoneyFormatter$Companion$create$1).format = function (money, locale) {
    return format(money, replace(locale, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)), this.a9_1.numberFormat, this.a9_1.currencyRepresentationOption, this.a9_1.denominationOption, this.a9_1.signOption, this.a9_1.zeroBiasOption);
  };
  function Companion() {
    Companion_instance = this;
    this.b9_1 = this.j9(Companion_getInstance().STANDARD);
    this.c9_1 = this.j9(Companion_getInstance().ACCOUNTING);
    this.d9_1 = this.j9(Companion_getInstance().CODE);
    this.e9_1 = this.j9(Companion_getInstance().COMPACT);
    this.f9_1 = this.j9(Companion_getInstance().COMPACT_CODE);
    this.g9_1 = this.j9(Companion_getInstance().COMPACT_POSITIVE_SIGN_ONLY);
    this.h9_1 = this.j9(Companion_getInstance().COMPACT_SYMBOL_AND_CODE);
    this.i9_1 = this.j9(Companion_getInstance().CENTS);
  }
  protoOf(Companion).k9 = function (numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption) {
    return this.j9(new MoneyFormatterConfig(numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption));
  };
  protoOf(Companion).j9 = function (config) {
    return new MoneyFormatter$Companion$create$1(config);
  };
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function MoneyFormatter() {
  }
  var NumberStyle_CURRENCY_instance;
  var NumberStyle_CURRENCY_ACCOUNTING_instance;
  var NumberStyle_NUMBER_instance;
  var NumberStyle_entriesInitialized;
  function NumberStyle_initEntries() {
    if (NumberStyle_entriesInitialized)
      return Unit_getInstance();
    NumberStyle_entriesInitialized = true;
    NumberStyle_CURRENCY_instance = new NumberStyle('CURRENCY', 0);
    NumberStyle_CURRENCY_ACCOUNTING_instance = new NumberStyle('CURRENCY_ACCOUNTING', 1);
    NumberStyle_NUMBER_instance = new NumberStyle('NUMBER', 2);
  }
  function NumberStyle(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NumberStyle_CURRENCY_getInstance() {
    NumberStyle_initEntries();
    return NumberStyle_CURRENCY_instance;
  }
  function NumberStyle_CURRENCY_ACCOUNTING_getInstance() {
    NumberStyle_initEntries();
    return NumberStyle_CURRENCY_ACCOUNTING_instance;
  }
  function NumberStyle_NUMBER_getInstance() {
    NumberStyle_initEntries();
    return NumberStyle_NUMBER_instance;
  }
  var Currency_AUD_instance;
  var Currency_BTC_instance;
  var Currency_CAD_instance;
  var Currency_EUR_instance;
  var Currency_GBP_instance;
  var Currency_JPY_instance;
  var Currency_MXN_instance;
  var Currency_USD_instance;
  var Currency_XTS_instance;
  var Currency_XUS_instance;
  var Currency_XXX_instance;
  function Companion_0() {
    Companion_instance_0 = this;
  }
  protoOf(Companion_0).fromISOTextCode = function (code) {
    return this.toCurrencyFromISOTextCode(Companion_getInstance_3().fromCode(code));
  };
  protoOf(Companion_0).fromISONumericCode = function (code) {
    return this.toCurrencyFromISONumericCode(Companion_getInstance_2().fromCode(code));
  };
  protoOf(Companion_0).toCurrencyFromISOTextCode = function (_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p6_1) {
      case 0:
        tmp = Currency_AUD_getInstance();
        break;
      case 1:
        tmp = Currency_BTC_getInstance();
        break;
      case 2:
        tmp = Currency_CAD_getInstance();
        break;
      case 3:
        tmp = Currency_EUR_getInstance();
        break;
      case 4:
        tmp = Currency_GBP_getInstance();
        break;
      case 5:
        tmp = Currency_JPY_getInstance();
        break;
      case 6:
        tmp = Currency_MXN_getInstance();
        break;
      case 7:
        tmp = Currency_USD_getInstance();
        break;
      case 8:
        tmp = Currency_XTS_getInstance();
        break;
      case 9:
        tmp = Currency_XUS_getInstance();
        break;
      case 10:
        tmp = Currency_XXX_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(Companion_0).toCurrencyFromISONumericCode = function (_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p6_1) {
      case 0:
        tmp = Currency_AUD_getInstance();
        break;
      case 1:
        tmp = Currency_BTC_getInstance();
        break;
      case 2:
        tmp = Currency_CAD_getInstance();
        break;
      case 3:
        tmp = Currency_EUR_getInstance();
        break;
      case 4:
        tmp = Currency_GBP_getInstance();
        break;
      case 5:
        tmp = Currency_JPY_getInstance();
        break;
      case 6:
        tmp = Currency_MXN_getInstance();
        break;
      case 7:
        tmp = Currency_USD_getInstance();
        break;
      case 8:
        tmp = Currency_XTS_getInstance();
        break;
      case 9:
        tmp = Currency_XUS_getInstance();
        break;
      case 10:
        tmp = Currency_XXX_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var Companion_instance_0;
  function Companion_getInstance_1() {
    Currency_initEntries();
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function values() {
    return [Currency_AUD_getInstance(), Currency_BTC_getInstance(), Currency_CAD_getInstance(), Currency_EUR_getInstance(), Currency_GBP_getInstance(), Currency_JPY_getInstance(), Currency_MXN_getInstance(), Currency_USD_getInstance(), Currency_XTS_getInstance(), Currency_XUS_getInstance(), Currency_XXX_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'AUD':
        return Currency_AUD_getInstance();
      case 'BTC':
        return Currency_BTC_getInstance();
      case 'CAD':
        return Currency_CAD_getInstance();
      case 'EUR':
        return Currency_EUR_getInstance();
      case 'GBP':
        return Currency_GBP_getInstance();
      case 'JPY':
        return Currency_JPY_getInstance();
      case 'MXN':
        return Currency_MXN_getInstance();
      case 'USD':
        return Currency_USD_getInstance();
      case 'XTS':
        return Currency_XTS_getInstance();
      case 'XUS':
        return Currency_XUS_getInstance();
      case 'XXX':
        return Currency_XXX_getInstance();
      default:
        Currency_initEntries();
        THROW_ISE();
        break;
    }
  }
  var Currency_entriesInitialized;
  function Currency_initEntries() {
    if (Currency_entriesInitialized)
      return Unit_getInstance();
    Currency_entriesInitialized = true;
    Currency_AUD_instance = new Currency('AUD', 0, ISOTextCode_AUD_getInstance(), ISONumericCode_AUD_getInstance(), '$', 'AU Dollars', 2, 'c', 'cent', 'cents');
    Currency_BTC_instance = new Currency('BTC', 1, ISOTextCode_BTC_getInstance(), ISONumericCode_BTC_getInstance(), '\u20BF', 'Bitcoin', 8, VOID, 'sat', 'sats', TrailingZeroesBehavior_SHOW_NONE_getInstance());
    Currency_CAD_instance = new Currency('CAD', 2, ISOTextCode_CAD_getInstance(), ISONumericCode_CAD_getInstance(), '$', 'CA Dollars', 2, '\xA2', 'cent', 'cents');
    Currency_EUR_instance = new Currency('EUR', 3, ISOTextCode_EUR_getInstance(), ISONumericCode_EUR_getInstance(), '\u20AC', 'Euros', 2, null, 'cent', 'cents');
    Currency_GBP_instance = new Currency('GBP', 4, ISOTextCode_GBP_getInstance(), ISONumericCode_GBP_getInstance(), '\xA3', 'GB Pounds', 2, 'p', 'penny', 'pence');
    Currency_JPY_instance = new Currency('JPY', 5, ISOTextCode_JPY_getInstance(), ISONumericCode_JPY_getInstance(), '\xA5', 'Japanese Yen', 0);
    Currency_MXN_instance = new Currency('MXN', 6, ISOTextCode_MXN_getInstance(), ISONumericCode_MXN_getInstance(), '$', 'Mexican Pesos', 2, '\xA2', 'centavo', 'centavos');
    Currency_USD_instance = new Currency('USD', 7, ISOTextCode_USD_getInstance(), ISONumericCode_USD_getInstance(), '$', 'US Dollars', 2, '\xA2', 'cent', 'cents');
    Currency_XTS_instance = new Currency('XTS', 8, ISOTextCode_XTS_getInstance(), ISONumericCode_XTS_getInstance(), '\xA4', 'Currency Units', 0);
    var tmp0_isoTextCode = ISOTextCode_USD_getInstance();
    var tmp1_numericCode = ISONumericCode_XUS_getInstance();
    var tmp2_trailingZeroesBehavior = TrailingZeroesBehavior_SHOW_TWO_getInstance();
    Currency_XUS_instance = new Currency('XUS', 9, tmp0_isoTextCode, tmp1_numericCode, '$', 'USDC', 6, '\xA2', 'cent', 'cents', tmp2_trailingZeroesBehavior, 'USDC');
    Currency_XXX_instance = new Currency('XXX', 10, ISOTextCode_XXX_getInstance(), ISONumericCode_XXX_getInstance(), '', '', 0);
    Companion_getInstance_1();
  }
  function Currency(name, ordinal, isoTextCode, numericCode, dollarSymbol, displayNamePlural, centDigits, centSymbol, centName, centNamePlural, trailingZeroesBehavior, syntheticTextCode) {
    centSymbol = centSymbol === VOID ? null : centSymbol;
    centName = centName === VOID ? null : centName;
    centNamePlural = centNamePlural === VOID ? null : centNamePlural;
    trailingZeroesBehavior = trailingZeroesBehavior === VOID ? TrailingZeroesBehavior_SHOW_ALL_getInstance() : trailingZeroesBehavior;
    syntheticTextCode = syntheticTextCode === VOID ? null : syntheticTextCode;
    Enum.call(this, name, ordinal);
    this.isoTextCode = isoTextCode;
    this.numericCode = numericCode;
    this.dollarSymbol = dollarSymbol;
    this.x8_1 = displayNamePlural;
    this.centDigits = centDigits;
    this.centSymbol = centSymbol;
    this.y8_1 = centName;
    this.z8_1 = centNamePlural;
    this.trailingZeroesBehavior = trailingZeroesBehavior;
    this.syntheticTextCode = syntheticTextCode;
  }
  protoOf(Currency).l9 = function () {
    return this.isoTextCode;
  };
  protoOf(Currency).m9 = function () {
    return this.numericCode;
  };
  protoOf(Currency).n9 = function () {
    return this.dollarSymbol;
  };
  protoOf(Currency).o9 = function () {
    return this.centDigits;
  };
  protoOf(Currency).p9 = function () {
    return this.centSymbol;
  };
  protoOf(Currency).j7 = function () {
    return this.trailingZeroesBehavior;
  };
  protoOf(Currency).q9 = function () {
    return this.syntheticTextCode;
  };
  protoOf(Currency).centsAmount = function (amount) {
    // Inline function 'kotlin.math.pow' call
    var tmp0_pow = this.centDigits;
    return Math.pow(amount, tmp0_pow);
  };
  protoOf(Currency).dollarAmount = function (amount) {
    // Inline function 'kotlin.math.pow' call
    var tmp0_pow = imul(-1, this.centDigits);
    return Math.pow(amount, tmp0_pow);
  };
  protoOf(Currency).centsPerDollar = function () {
    return numberToInt(this.centsAmount(1.0));
  };
  protoOf(Currency).centString = function (amountOfCents) {
    return amountOfCents.absoluteValue().equals(Companion_getInstance_4().ONE) ? this.y8_1 : this.z8_1;
  };
  function Currency_AUD_getInstance() {
    Currency_initEntries();
    return Currency_AUD_instance;
  }
  function Currency_BTC_getInstance() {
    Currency_initEntries();
    return Currency_BTC_instance;
  }
  function Currency_CAD_getInstance() {
    Currency_initEntries();
    return Currency_CAD_instance;
  }
  function Currency_EUR_getInstance() {
    Currency_initEntries();
    return Currency_EUR_instance;
  }
  function Currency_GBP_getInstance() {
    Currency_initEntries();
    return Currency_GBP_instance;
  }
  function Currency_JPY_getInstance() {
    Currency_initEntries();
    return Currency_JPY_instance;
  }
  function Currency_MXN_getInstance() {
    Currency_initEntries();
    return Currency_MXN_instance;
  }
  function Currency_USD_getInstance() {
    Currency_initEntries();
    return Currency_USD_instance;
  }
  function Currency_XTS_getInstance() {
    Currency_initEntries();
    return Currency_XTS_instance;
  }
  function Currency_XUS_getInstance() {
    Currency_initEntries();
    return Currency_XUS_instance;
  }
  function Currency_XXX_getInstance() {
    Currency_initEntries();
    return Currency_XXX_instance;
  }
  var ISONumericCode_AUD_instance;
  var ISONumericCode_BTC_instance;
  var ISONumericCode_CAD_instance;
  var ISONumericCode_EUR_instance;
  var ISONumericCode_GBP_instance;
  var ISONumericCode_JPY_instance;
  var ISONumericCode_MXN_instance;
  var ISONumericCode_USD_instance;
  var ISONumericCode_XTS_instance;
  var ISONumericCode_XUS_instance;
  var ISONumericCode_XXX_instance;
  function Companion_1() {
    Companion_instance_1 = this;
  }
  protoOf(Companion_1).fromCode = function (code) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var indexedObject = values_0();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.squareup.cash.common.moneyformatter.currency.Companion.fromCode.<anonymous>' call
        if (element.code === code) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? ISONumericCode_XXX_getInstance() : tmp0_elvis_lhs;
  };
  var Companion_instance_1;
  function Companion_getInstance_2() {
    ISONumericCode_initEntries();
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function values_0() {
    return [ISONumericCode_AUD_getInstance(), ISONumericCode_BTC_getInstance(), ISONumericCode_CAD_getInstance(), ISONumericCode_EUR_getInstance(), ISONumericCode_GBP_getInstance(), ISONumericCode_JPY_getInstance(), ISONumericCode_MXN_getInstance(), ISONumericCode_USD_getInstance(), ISONumericCode_XTS_getInstance(), ISONumericCode_XUS_getInstance(), ISONumericCode_XXX_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'AUD':
        return ISONumericCode_AUD_getInstance();
      case 'BTC':
        return ISONumericCode_BTC_getInstance();
      case 'CAD':
        return ISONumericCode_CAD_getInstance();
      case 'EUR':
        return ISONumericCode_EUR_getInstance();
      case 'GBP':
        return ISONumericCode_GBP_getInstance();
      case 'JPY':
        return ISONumericCode_JPY_getInstance();
      case 'MXN':
        return ISONumericCode_MXN_getInstance();
      case 'USD':
        return ISONumericCode_USD_getInstance();
      case 'XTS':
        return ISONumericCode_XTS_getInstance();
      case 'XUS':
        return ISONumericCode_XUS_getInstance();
      case 'XXX':
        return ISONumericCode_XXX_getInstance();
      default:
        ISONumericCode_initEntries();
        THROW_ISE();
        break;
    }
  }
  var ISONumericCode_entriesInitialized;
  function ISONumericCode_initEntries() {
    if (ISONumericCode_entriesInitialized)
      return Unit_getInstance();
    ISONumericCode_entriesInitialized = true;
    ISONumericCode_AUD_instance = new ISONumericCode('AUD', 0, 36);
    ISONumericCode_BTC_instance = new ISONumericCode('BTC', 1, 1001);
    ISONumericCode_CAD_instance = new ISONumericCode('CAD', 2, 124);
    ISONumericCode_EUR_instance = new ISONumericCode('EUR', 3, 978);
    ISONumericCode_GBP_instance = new ISONumericCode('GBP', 4, 826);
    ISONumericCode_JPY_instance = new ISONumericCode('JPY', 5, 392);
    ISONumericCode_MXN_instance = new ISONumericCode('MXN', 6, 484);
    ISONumericCode_USD_instance = new ISONumericCode('USD', 7, 840);
    ISONumericCode_XTS_instance = new ISONumericCode('XTS', 8, 963);
    ISONumericCode_XUS_instance = new ISONumericCode('XUS', 9, 1002);
    ISONumericCode_XXX_instance = new ISONumericCode('XXX', 10, 999);
    Companion_getInstance_2();
  }
  function ISONumericCode(name, ordinal, code) {
    Enum.call(this, name, ordinal);
    this.code = code;
  }
  protoOf(ISONumericCode).t9 = function () {
    return this.code;
  };
  function ISONumericCode_AUD_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_AUD_instance;
  }
  function ISONumericCode_BTC_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_BTC_instance;
  }
  function ISONumericCode_CAD_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_CAD_instance;
  }
  function ISONumericCode_EUR_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_EUR_instance;
  }
  function ISONumericCode_GBP_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_GBP_instance;
  }
  function ISONumericCode_JPY_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_JPY_instance;
  }
  function ISONumericCode_MXN_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_MXN_instance;
  }
  function ISONumericCode_USD_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_USD_instance;
  }
  function ISONumericCode_XTS_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_XTS_instance;
  }
  function ISONumericCode_XUS_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_XUS_instance;
  }
  function ISONumericCode_XXX_getInstance() {
    ISONumericCode_initEntries();
    return ISONumericCode_XXX_instance;
  }
  var ISOTextCode_AUD_instance;
  var ISOTextCode_BTC_instance;
  var ISOTextCode_CAD_instance;
  var ISOTextCode_EUR_instance;
  var ISOTextCode_GBP_instance;
  var ISOTextCode_JPY_instance;
  var ISOTextCode_MXN_instance;
  var ISOTextCode_USD_instance;
  var ISOTextCode_XTS_instance;
  var ISOTextCode_XUS_instance;
  var ISOTextCode_XXX_instance;
  function Companion_2() {
    Companion_instance_2 = this;
  }
  protoOf(Companion_2).fromCode = function (code) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var indexedObject = values_1();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.squareup.cash.common.moneyformatter.currency.Companion.fromCode.<anonymous>' call
        if (element.code === code) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? ISOTextCode_XXX_getInstance() : tmp0_elvis_lhs;
  };
  var Companion_instance_2;
  function Companion_getInstance_3() {
    ISOTextCode_initEntries();
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function values_1() {
    return [ISOTextCode_AUD_getInstance(), ISOTextCode_BTC_getInstance(), ISOTextCode_CAD_getInstance(), ISOTextCode_EUR_getInstance(), ISOTextCode_GBP_getInstance(), ISOTextCode_JPY_getInstance(), ISOTextCode_MXN_getInstance(), ISOTextCode_USD_getInstance(), ISOTextCode_XTS_getInstance(), ISOTextCode_XUS_getInstance(), ISOTextCode_XXX_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'AUD':
        return ISOTextCode_AUD_getInstance();
      case 'BTC':
        return ISOTextCode_BTC_getInstance();
      case 'CAD':
        return ISOTextCode_CAD_getInstance();
      case 'EUR':
        return ISOTextCode_EUR_getInstance();
      case 'GBP':
        return ISOTextCode_GBP_getInstance();
      case 'JPY':
        return ISOTextCode_JPY_getInstance();
      case 'MXN':
        return ISOTextCode_MXN_getInstance();
      case 'USD':
        return ISOTextCode_USD_getInstance();
      case 'XTS':
        return ISOTextCode_XTS_getInstance();
      case 'XUS':
        return ISOTextCode_XUS_getInstance();
      case 'XXX':
        return ISOTextCode_XXX_getInstance();
      default:
        ISOTextCode_initEntries();
        THROW_ISE();
        break;
    }
  }
  var ISOTextCode_entriesInitialized;
  function ISOTextCode_initEntries() {
    if (ISOTextCode_entriesInitialized)
      return Unit_getInstance();
    ISOTextCode_entriesInitialized = true;
    ISOTextCode_AUD_instance = new ISOTextCode('AUD', 0, 'AUD');
    ISOTextCode_BTC_instance = new ISOTextCode('BTC', 1, 'BTC');
    ISOTextCode_CAD_instance = new ISOTextCode('CAD', 2, 'CAD');
    ISOTextCode_EUR_instance = new ISOTextCode('EUR', 3, 'EUR');
    ISOTextCode_GBP_instance = new ISOTextCode('GBP', 4, 'GBP');
    ISOTextCode_JPY_instance = new ISOTextCode('JPY', 5, 'JPY');
    ISOTextCode_MXN_instance = new ISOTextCode('MXN', 6, 'MXN');
    ISOTextCode_USD_instance = new ISOTextCode('USD', 7, 'USD');
    ISOTextCode_XTS_instance = new ISOTextCode('XTS', 8, 'XTS');
    ISOTextCode_XUS_instance = new ISOTextCode('XUS', 9, 'USDC');
    ISOTextCode_XXX_instance = new ISOTextCode('XXX', 10, 'XXX');
    Companion_getInstance_3();
  }
  function ISOTextCode(name, ordinal, code) {
    Enum.call(this, name, ordinal);
    this.code = code;
  }
  protoOf(ISOTextCode).t9 = function () {
    return this.code;
  };
  function ISOTextCode_AUD_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_AUD_instance;
  }
  function ISOTextCode_BTC_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_BTC_instance;
  }
  function ISOTextCode_CAD_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_CAD_instance;
  }
  function ISOTextCode_EUR_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_EUR_instance;
  }
  function ISOTextCode_GBP_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_GBP_instance;
  }
  function ISOTextCode_JPY_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_JPY_instance;
  }
  function ISOTextCode_MXN_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_MXN_instance;
  }
  function ISOTextCode_USD_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_USD_instance;
  }
  function ISOTextCode_XTS_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_XTS_instance;
  }
  function ISOTextCode_XUS_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_XUS_instance;
  }
  function ISOTextCode_XXX_getInstance() {
    ISOTextCode_initEntries();
    return ISOTextCode_XXX_instance;
  }
  function toDecimal(_this__u8e3s4, $this) {
    return _this__u8e3s4 - numberToLong(_this__u8e3s4).t6();
  }
  function Amount_init_$Init$(value, $this) {
    var tmp = value.a2(new Long(0, 0)) < 0;
    var tmp$ret$0;
    // Inline function 'kotlin.math.absoluteValue' call
    tmp$ret$0 = abs(value);
    Amount.call($this, tmp, tmp$ret$0, 0.0);
    return $this;
  }
  function fromLong(value) {
    return Amount_init_$Init$(value, objectCreate(protoOf(Amount)));
  }
  function Amount_init_$Init$_0(value, $this) {
    Amount_init_$Init$(toLong_0(value), $this);
    return $this;
  }
  function fromBigInt(value) {
    return Amount_init_$Init$_0(value, objectCreate(protoOf(Amount)));
  }
  function roundUp($this) {
    return roundAwayFromZero($this);
  }
  function roundDown($this) {
    return roundTowardZero($this);
  }
  function roundCeiling($this) {
    var tmp;
    if ($this.isNegative) {
      tmp = roundTowardZero($this);
    } else {
      tmp = roundAwayFromZero($this);
    }
    return tmp;
  }
  function roundFloor($this) {
    var tmp;
    if ($this.isNegative) {
      tmp = roundAwayFromZero($this);
    } else {
      tmp = roundTowardZero($this);
    }
    return tmp;
  }
  function roundHalfUp($this) {
    var tmp;
    if ($this.decimal >= 0.5) {
      tmp = roundAwayFromZero($this);
    } else {
      tmp = roundTowardZero($this);
    }
    return tmp;
  }
  function roundHalfDown($this) {
    var tmp;
    if ($this.decimal > 0.5) {
      tmp = roundAwayFromZero($this);
    } else {
      tmp = roundTowardZero($this);
    }
    return tmp;
  }
  function roundHalfEven($this) {
    var tmp;
    if ($this.decimal > 0.5) {
      tmp = roundAwayFromZero($this);
    } else if ($this.decimal < 0.5) {
      tmp = roundTowardZero($this);
    } else {
      var tmp_0;
      if ($this.integer.y6(new Long(2, 0)).equals(new Long(0, 0))) {
        tmp_0 = roundTowardZero($this);
      } else {
        tmp_0 = roundAwayFromZero($this);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function roundAwayFromZero($this) {
    var tmp;
    if ($this.isWholeNumber()) {
      tmp = $this;
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.Long.plus' call
      tmp$ret$0 = $this.integer.c2(new Long(1, 0));
      tmp = new Amount($this.isNegative, tmp$ret$0, 0.0);
    }
    return tmp;
  }
  function roundTowardZero($this) {
    var tmp;
    if ($this.isWholeNumber()) {
      tmp = $this;
    } else {
      var isNegativeAfterRounding = $this.isNegative ? !$this.integer.equals(new Long(0, 0)) : false;
      tmp = new Amount(isNegativeAfterRounding, $this.integer, 0.0);
    }
    return tmp;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    this.ZERO = toAmount(new Long(0, 0));
    this.ONE = toAmount(new Long(1, 0));
  }
  protoOf(Companion_3).w9 = function () {
    return this.ZERO;
  };
  protoOf(Companion_3).x9 = function () {
    return this.ONE;
  };
  var Companion_instance_3;
  function Companion_getInstance_4() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function Amount(isNegative, integer, decimal) {
    Companion_getInstance_4();
    this.isNegative = isNegative;
    this.integer = integer;
    this.decimal = decimal;
  }
  protoOf(Amount).y9 = function () {
    return this.isNegative;
  };
  protoOf(Amount).z9 = function () {
    return this.integer;
  };
  protoOf(Amount).aa = function () {
    return this.decimal;
  };
  protoOf(Amount).p = function () {
    var prefixString = this.isNegative ? '-' : '';
    var integerString = this.integer.toString();
    var decimalString = removePrefix(this.decimal.toString(), '0');
    return prefixString + integerString + decimalString;
  };
  protoOf(Amount).compareTo = function (other) {
    var signedInteger = this.isNegative ? this.integer.y1() : this.integer;
    var otherSignedInteger = other.isNegative ? other.integer.y1() : other.integer;
    var integerResult = signedInteger.a2(otherSignedInteger);
    if (!(integerResult === 0))
      return integerResult;
    var signedDecimal = this.isNegative ? -this.decimal : this.decimal;
    var otherSignedDecimal = other.isNegative ? -other.decimal : other.decimal;
    return compareTo(signedDecimal, otherSignedDecimal);
  };
  protoOf(Amount).absoluteValue = function () {
    return new Amount(false, this.integer, this.decimal);
  };
  protoOf(Amount).isWholeNumber = function () {
    return this.decimal === 0.0;
  };
  protoOf(Amount).isZero = function () {
    return this.integer.equals(new Long(0, 0)) ? this.decimal === 0.0 : false;
  };
  protoOf(Amount).ba = function (decimalPlaces, roundingMode) {
    return this.shiftDecimalPoint(decimalPlaces).roundToWholeNumber(roundingMode).shiftDecimalPoint(-decimalPlaces | 0);
  };
  protoOf(Amount).round = function (decimalPlaces, roundingMode, $super) {
    roundingMode = roundingMode === VOID ? RoundingMode_HALF_UP_getInstance() : roundingMode;
    return this.ba(decimalPlaces, roundingMode);
  };
  protoOf(Amount).ca = function (roundingMode) {
    var tmp;
    switch (roundingMode.p6_1) {
      case 0:
        tmp = roundUp(this);
        break;
      case 1:
        tmp = roundDown(this);
        break;
      case 2:
        tmp = roundCeiling(this);
        break;
      case 3:
        tmp = roundFloor(this);
        break;
      case 4:
        tmp = roundHalfUp(this);
        break;
      case 5:
        tmp = roundHalfDown(this);
        break;
      case 6:
        tmp = roundHalfEven(this);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(Amount).roundToWholeNumber = function (roundingMode, $super) {
    roundingMode = roundingMode === VOID ? RoundingMode_HALF_UP_getInstance() : roundingMode;
    return this.ca(roundingMode);
  };
  protoOf(Amount).shiftDecimalPoint = function (places) {
    // Inline function 'kotlin.math.pow' call
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp0_pow = abs_0(places);
    var factor = Math.pow(10.0, tmp0_pow);
    var shiftedInteger;
    var shiftedDecimal;
    if (places < 0) {
      shiftedInteger = this.integer.z1(numberToLong(factor));
      shiftedDecimal = (this.decimal + this.integer.y6(numberToLong(factor)).t6()) / factor;
    } else {
      shiftedDecimal = toDecimal(this.decimal * factor, Companion_getInstance_4());
      shiftedInteger = this.integer.b2(numberToLong(factor)).c2(numberToLong(this.decimal * factor));
    }
    return new Amount(this.isNegative, shiftedInteger, shiftedDecimal);
  };
  protoOf(Amount).d8 = function () {
    return this.isNegative;
  };
  protoOf(Amount).e8 = function () {
    return this.integer;
  };
  protoOf(Amount).f8 = function () {
    return this.decimal;
  };
  protoOf(Amount).da = function (isNegative, integer, decimal) {
    return new Amount(isNegative, integer, decimal);
  };
  protoOf(Amount).copy = function (isNegative, integer, decimal, $super) {
    isNegative = isNegative === VOID ? this.isNegative : isNegative;
    integer = integer === VOID ? this.integer : integer;
    decimal = decimal === VOID ? this.decimal : decimal;
    return this.da(isNegative, integer, decimal);
  };
  protoOf(Amount).toString = function () {
    return 'Amount(isNegative=' + this.isNegative + ', integer=' + toString(this.integer) + ', decimal=' + this.decimal + ')';
  };
  protoOf(Amount).hashCode = function () {
    var result = this.isNegative | 0;
    result = imul(result, 31) + this.integer.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.decimal) | 0;
    return result;
  };
  protoOf(Amount).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Amount))
      return false;
    var tmp0_other_with_cast = other instanceof Amount ? other : THROW_CCE();
    if (!(this.isNegative === tmp0_other_with_cast.isNegative))
      return false;
    if (!this.integer.equals(tmp0_other_with_cast.integer))
      return false;
    if (!equals(this.decimal, tmp0_other_with_cast.decimal))
      return false;
    return true;
  };
  function toLong_0(_this__u8e3s4) {
    return toLong(toString(_this__u8e3s4));
  }
  function NumberFormat(_this__u8e3s4, locale, currency, currencyDisplay, currencySign, minimumFractionDigits, maximumFractionDigits, signDisplay, style) {
    return new Intl.NumberFormat(locale, new NumberFormat$1(currency, currencyDisplay, currencySign, minimumFractionDigits, maximumFractionDigits, signDisplay, style));
  }
  function NumberFormat$1($currency, $currencyDisplay, $currencySign, $minimumFractionDigits, $maximumFractionDigits, $signDisplay, $style) {
    this.ea_1 = $currency;
    this.fa_1 = $currencyDisplay;
    this.ga_1 = $currencySign;
    this.ha_1 = $minimumFractionDigits;
    this.ia_1 = $maximumFractionDigits;
    this.ja_1 = $signDisplay;
    this.ka_1 = $style;
  }
  protoOf(NumberFormat$1).la = function () {
    return this.ea_1;
  };
  protoOf(NumberFormat$1).ma = function () {
    return this.fa_1;
  };
  protoOf(NumberFormat$1).na = function () {
    return this.ga_1;
  };
  protoOf(NumberFormat$1).n7 = function () {
    return this.ha_1;
  };
  protoOf(NumberFormat$1).o7 = function () {
    return this.ia_1;
  };
  protoOf(NumberFormat$1).oa = function () {
    return this.ja_1;
  };
  protoOf(NumberFormat$1).pa = function () {
    return this.ka_1;
  };
  function Money_init_$Init$(centsAmount, currency, $this) {
    Money.call($this, toAmount(centsAmount), currency);
    return $this;
  }
  function fromLong_0(centsAmount, currency) {
    return Money_init_$Init$(centsAmount, currency, objectCreate(protoOf(Money)));
  }
  function Money_init_$Init$_0(centsAmount, currency, $this) {
    Money_init_$Init$(toLong_0(centsAmount), currency, $this);
    return $this;
  }
  function fromBigInt_0(centsAmount, currency) {
    return Money_init_$Init$_0(centsAmount, currency, objectCreate(protoOf(Money)));
  }
  function Money(centsAmount, currency) {
    this.centsAmount = centsAmount;
    this.currency = currency;
  }
  protoOf(Money).qa = function () {
    return this.centsAmount;
  };
  protoOf(Money).la = function () {
    return this.currency;
  };
  protoOf(Money).d8 = function () {
    return this.centsAmount;
  };
  protoOf(Money).e8 = function () {
    return this.currency;
  };
  protoOf(Money).ra = function (centsAmount, currency) {
    return new Money(centsAmount, currency);
  };
  protoOf(Money).copy = function (centsAmount, currency, $super) {
    centsAmount = centsAmount === VOID ? this.centsAmount : centsAmount;
    currency = currency === VOID ? this.currency : currency;
    return this.ra(centsAmount, currency);
  };
  protoOf(Money).toString = function () {
    return 'Money(centsAmount=' + this.centsAmount + ', currency=' + this.currency + ')';
  };
  protoOf(Money).hashCode = function () {
    var result = this.centsAmount.hashCode();
    result = imul(result, 31) + this.currency.hashCode() | 0;
    return result;
  };
  protoOf(Money).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Money))
      return false;
    var tmp0_other_with_cast = other instanceof Money ? other : THROW_CCE();
    if (!this.centsAmount.equals(tmp0_other_with_cast.centsAmount))
      return false;
    if (!this.currency.equals(tmp0_other_with_cast.currency))
      return false;
    return true;
  };
  function get_STANDARD() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return STANDARD;
  }
  var STANDARD;
  function get_ACCOUNTING() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return ACCOUNTING;
  }
  var ACCOUNTING;
  function get_CODE() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return CODE;
  }
  var CODE;
  function get_COMPACT() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return COMPACT;
  }
  var COMPACT;
  function get_COMPACT_CODE() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return COMPACT_CODE;
  }
  var COMPACT_CODE;
  function get_COMPACT_POSITIVE_SIGN_ONLY() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return COMPACT_POSITIVE_SIGN_ONLY;
  }
  var COMPACT_POSITIVE_SIGN_ONLY;
  function get_COMPACT_SYMBOL_AND_CODE() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return COMPACT_SYMBOL_AND_CODE;
  }
  var COMPACT_SYMBOL_AND_CODE;
  function get_CENTS() {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return CENTS;
  }
  var CENTS;
  function createMoneyFormatter(numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption) {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    return Companion_getInstance_0().k9(numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption);
  }
  function format_0(amount, currency, locale, fractionDigitRange, numberStyle) {
    _init_properties_MoneyFormatter_kt__v6dqk6();
    var dollarSymbol = currency.dollarSymbol === '$' ? '\\$' : currency.dollarSymbol;
    var regex = Regex_init_$Create$('[a-zA-Z]*' + dollarSymbol + '[a-zA-Z]*\xA0?');
    // Inline function 'kotlin.text.replace' call
    var tmp = Intl;
    var tmp_0;
    switch (numberStyle.p6_1) {
      case 0:
        tmp_0 = 'standard';
        break;
      case 1:
        tmp_0 = 'accounting';
        break;
      case 2:
        tmp_0 = 'standard';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_1 = tmp_0;
    var tmp_2;
    switch (numberStyle.p6_1) {
      case 0:
      case 1:
        tmp_2 = 'currency';
        break;
      case 2:
        tmp_2 = 'decimal';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_3 = NumberFormat(tmp, locale, currency.isoTextCode.o6_1, 'symbol', tmp_1, fractionDigitRange.m1_1, fractionDigitRange.n1_1, 'auto', tmp_2).formatToParts(amount.value);
    var tmp0_replace = joinToString(tmp_3, '', VOID, VOID, VOID, VOID, format$lambda(currency));
    return regex.l5(tmp0_replace, dollarSymbol);
  }
  function format$lambda($currency) {
    return function (it) {
      var tmp0_subject = it.type;
      switch (tmp0_subject) {
        case 'currency':
          return $currency.equals(Currency_BTC_getInstance()) ? $currency.o6_1 : $currency.dollarSymbol;
        case 'minusSign':
          return '' + new Char(get_MINUS());
        default:
          return it.value;
      }
    };
  }
  var properties_initialized_MoneyFormatter_kt_5cwllg;
  function _init_properties_MoneyFormatter_kt__v6dqk6() {
    if (!properties_initialized_MoneyFormatter_kt_5cwllg) {
      properties_initialized_MoneyFormatter_kt_5cwllg = true;
      STANDARD = Companion_getInstance_0().b9_1;
      ACCOUNTING = Companion_getInstance_0().c9_1;
      CODE = Companion_getInstance_0().d9_1;
      COMPACT = Companion_getInstance_0().e9_1;
      COMPACT_CODE = Companion_getInstance_0().f9_1;
      COMPACT_POSITIVE_SIGN_ONLY = Companion_getInstance_0().g9_1;
      COMPACT_SYMBOL_AND_CODE = Companion_getInstance_0().h9_1;
      CENTS = Companion_getInstance_0().i9_1;
    }
  }
  //region block: post-declaration
  defineProp(protoOf(Currency), 'name', protoOf(Currency).q6, VOID);
  defineProp(protoOf(Currency), 'ordinal', protoOf(Currency).r6, VOID);
  defineProp(protoOf(ISONumericCode), 'name', protoOf(ISONumericCode).q6, VOID);
  defineProp(protoOf(ISONumericCode), 'ordinal', protoOf(ISONumericCode).r6, VOID);
  defineProp(protoOf(ISOTextCode), 'name', protoOf(ISOTextCode).q6, VOID);
  defineProp(protoOf(ISOTextCode), 'ordinal', protoOf(ISOTextCode).r6, VOID);
  defineProp(protoOf(Amount), 'value', protoOf(Amount).p, VOID);
  defineProp(protoOf(NumberFormat$1), 'currency', function () {
    return this.la();
  }, VOID);
  defineProp(protoOf(NumberFormat$1), 'currencyDisplay', function () {
    return this.ma();
  }, VOID);
  defineProp(protoOf(NumberFormat$1), 'currencySign', function () {
    return this.na();
  }, VOID);
  defineProp(protoOf(NumberFormat$1), 'minimumFractionDigits', function () {
    return this.n7();
  }, VOID);
  defineProp(protoOf(NumberFormat$1), 'maximumFractionDigits', function () {
    return this.o7();
  }, VOID);
  defineProp(protoOf(NumberFormat$1), 'signDisplay', function () {
    return this.oa();
  }, VOID);
  defineProp(protoOf(NumberFormat$1), 'style', function () {
    return this.pa();
  }, VOID);
  //endregion
  //region block: init
  MINUS = _Char___init__impl__6a9atx(8722);
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.toAmount = toAmount;
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    var $com$squareup$cash$common$moneyformatter$currency = $com$squareup$cash$common$moneyformatter.currency || ($com$squareup$cash$common$moneyformatter.currency = {});
    $com$squareup$cash$common$moneyformatter$currency.Currency = Currency;
    $com$squareup$cash$common$moneyformatter$currency.Currency.values = values;
    $com$squareup$cash$common$moneyformatter$currency.Currency.valueOf = valueOf;
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'AUD', Currency_AUD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'BTC', Currency_BTC_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'CAD', Currency_CAD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'EUR', Currency_EUR_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'GBP', Currency_GBP_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'JPY', Currency_JPY_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'MXN', Currency_MXN_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'USD', Currency_USD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'XTS', Currency_XTS_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'XUS', Currency_XUS_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'XXX', Currency_XXX_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.Currency, 'Companion', Companion_getInstance_1, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    var $com$squareup$cash$common$moneyformatter$currency = $com$squareup$cash$common$moneyformatter.currency || ($com$squareup$cash$common$moneyformatter.currency = {});
    $com$squareup$cash$common$moneyformatter$currency.ISONumericCode = ISONumericCode;
    $com$squareup$cash$common$moneyformatter$currency.ISONumericCode.values = values_0;
    $com$squareup$cash$common$moneyformatter$currency.ISONumericCode.valueOf = valueOf_0;
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'AUD', ISONumericCode_AUD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'BTC', ISONumericCode_BTC_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'CAD', ISONumericCode_CAD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'EUR', ISONumericCode_EUR_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'GBP', ISONumericCode_GBP_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'JPY', ISONumericCode_JPY_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'MXN', ISONumericCode_MXN_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'USD', ISONumericCode_USD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'XTS', ISONumericCode_XTS_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'XUS', ISONumericCode_XUS_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'XXX', ISONumericCode_XXX_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISONumericCode, 'Companion', Companion_getInstance_2, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    var $com$squareup$cash$common$moneyformatter$currency = $com$squareup$cash$common$moneyformatter.currency || ($com$squareup$cash$common$moneyformatter.currency = {});
    $com$squareup$cash$common$moneyformatter$currency.ISOTextCode = ISOTextCode;
    $com$squareup$cash$common$moneyformatter$currency.ISOTextCode.values = values_1;
    $com$squareup$cash$common$moneyformatter$currency.ISOTextCode.valueOf = valueOf_1;
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'AUD', ISOTextCode_AUD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'BTC', ISOTextCode_BTC_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'CAD', ISOTextCode_CAD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'EUR', ISOTextCode_EUR_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'GBP', ISOTextCode_GBP_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'JPY', ISOTextCode_JPY_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'MXN', ISOTextCode_MXN_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'USD', ISOTextCode_USD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'XTS', ISOTextCode_XTS_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'XUS', ISOTextCode_XUS_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'XXX', ISOTextCode_XXX_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter$currency.ISOTextCode, 'Companion', Companion_getInstance_3, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.Amount = Amount;
    $com$squareup$cash$common$moneyformatter.Amount.fromLong = fromLong;
    $com$squareup$cash$common$moneyformatter.Amount.fromBigInt = fromBigInt;
    defineProp($com$squareup$cash$common$moneyformatter.Amount, 'Companion', Companion_getInstance_4, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.Money = Money;
    $com$squareup$cash$common$moneyformatter.Money.fromLong = fromLong_0;
    $com$squareup$cash$common$moneyformatter.Money.fromBigInt = fromBigInt_0;
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    defineProp($com$squareup$cash$common$moneyformatter, 'STANDARD', get_STANDARD, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'ACCOUNTING', get_ACCOUNTING, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'CODE', get_CODE, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'COMPACT', get_COMPACT, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'COMPACT_CODE', get_COMPACT_CODE, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'COMPACT_POSITIVE_SIGN_ONLY', get_COMPACT_POSITIVE_SIGN_ONLY, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'COMPACT_SYMBOL_AND_CODE', get_COMPACT_SYMBOL_AND_CODE, VOID);
    defineProp($com$squareup$cash$common$moneyformatter, 'CENTS', get_CENTS, VOID);
    $com$squareup$cash$common$moneyformatter.createMoneyFormatter = createMoneyFormatter;
  }
  $jsExportAll$(_);
  kotlin_com_squareup_cash_multiplatform_money_formatter_config.$jsExportAll$(_);
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./cash-mobile-multiplatform-money-formatter-config.js')));
